export const ActivityMonitorConstants = {
    MONITOR_INTERVAL_MS: 10 * 1000,
    COUNTDOWN_INTERVAL_MS: 100,
    TIME_TO_WARNING_MINS: 15,
    TIME_TO_SIGNOUT_MINS: 5
  };